import React from "react"
import {
    APIJobModel,
    JobStatus,
    JobType
} from "../../../../../../Models/API/JobModel"
import { Pill } from "dash-styled"

interface Props {
    job: Pick<APIJobModel, "correct" | "status" | "jobType">
    className?: string
    size?: "sm" | "md" | "lg"
}

export const JobStatusPill: React.FC<Props> = ({
    job,
    className,
    size
}: Props) => {
    const cls = `whitespace-no-wrap ${className ?? ""} ${
        size === "sm" ? "w-24" : "w-32"
    }`

    switch (job.status) {
        case JobStatus.COMPLETED:
            if (job.correct !== null) {
                return job.correct ? (
                    <Pill
                        state="correct"
                        label="Correct"
                        className={cls}
                        testId="correct-pill"
                        size={size}
                    />
                ) : (
                    <Pill
                        state="incorrect"
                        label="Incorrect"
                        className={cls}
                        testId="incorrect-pill"
                        size={size}
                    />
                )
            } else {
                return (
                    <Pill
                        state="complete"
                        label="Complete"
                        className={cls}
                        testId="complete-pill"
                        size={size}
                    />
                )
            }
        case JobStatus.CANCELED:
            return (
                <Pill
                    bgColor="black"
                    state="canceled"
                    label="Canceled"
                    className={cls}
                    testId="canceled-pill"
                    size={size}
                />
            )
        case JobStatus.EXPIRED:
            return (
                <Pill
                    bgColor="darkred"
                    state="expired"
                    label="Expired"
                    className={cls}
                    testId="expired-pill"
                    size={size}
                />
            )
        case JobStatus.FAILED:
            return (
                <Pill
                    bgColor="darkred"
                    state="failed"
                    label="Failed"
                    className={cls}
                    testId="failed-pill"
                    size={size}
                />
            )
        case JobStatus.SUSPENDED:
            return (
                <Pill
                    bgColor="pink"
                    state="suspended"
                    label="Paused"
                    className={cls}
                    testId="paused-pill"
                    size={size}
                />
            )
        case JobStatus.IN_PROGRESS:
        case JobStatus.INTERNAL_ERROR:
            return (
                <Pill
                    bgColor="gray"
                    state="in-progress"
                    label={
                        job.jobType === JobType.COLLABORATOR
                            ? "Ready to process"
                            : "In Progress"
                    }
                    className={cls}
                    testId="progress-pill"
                    size={size}
                />
            )
        case JobStatus.SCHEDULED:
        case JobStatus.ENQUEUED:
            return (
                <Pill
                    bgColor="lightgray"
                    state="scheduled"
                    label="Queued"
                    className={cls}
                    testId="queued-pill"
                    size={size}
                />
            )
        case JobStatus.PENDING:
            return (
                <Pill
                    bgColor="lightpink"
                    state="pending"
                    label="Parked"
                    className={cls}
                    testId="pending-pill"
                    size={size}
                />
            )
        case JobStatus.IN_CREATION:
            return (
                <Pill
                    state="in-creation"
                    label="Creating"
                    className={cls}
                    testId="in-creation-pill"
                    size={size}
                />
            )
        default:
            return <></>
    }
}
